import { TEST_ID_INVITATION } from "e2e/testId";
import { Link } from "expo-router";
import { PlusCircleIcon } from "lucide-react-native";
import { memo } from "react";

import { Box } from "@/components/atoms/Box";
import { Button } from "@/components/atoms/Button";

/**
 * View component for the create invitation navigation button.
 * Renders a plus icon button that links to the new invitation form.
 */
const CreateButtonView = () => (
  <Box className="pr-4">
    <Link asChild href="/invitations/new">
      {/* design-system: size snapped xl→lg (atom Button scale) */}
      <Button
        testID={TEST_ID_INVITATION.CREATE_BUTTON}
        size="lg"
        variant="link"
        accessibilityLabel="Create invitation"
        icon={PlusCircleIcon}
      />
    </Link>
  </Box>
);

CreateButtonView.displayName = "CreateButtonView";

export default memo(CreateButtonView);
